


























import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ElTree } from "element-ui/types/tree";
import { FormatReferenceTreeEditDialogModel } from ".";
import {
  FormatReference,
  IFormatReferenceTreeNode,
  IFormatReferenceTreeData
} from "../../../../../domain/format";
import { Directory } from "../../../../../domain/drawing";
import { TreeNodeDropType } from "../../../../../domain/system";
import { ModelEditableMixin } from "../../../../system/mixins";
import { DirectoryTreeNodesFactory } from "../../../../system/utilities/DirectoryTreeNodesFactory";
import { FormatTreeNodeUtility } from "../utilities";

@Component({
})
export default class FormatReferenceTreeEditor extends Mixins(ModelEditableMixin) {
  private static readonly _nodeUtility = new FormatTreeNodeUtility();

  mounted(): void {
    this.loadNodes();
  }

  data(): any {
    return {
      factory: null as DirectoryTreeNodesFactory<string, FormatReference>,
      nodes: null as IFormatReferenceTreeData[],
      selectedNode: null as IFormatReferenceTreeNode,
    };
  }
  factory: DirectoryTreeNodesFactory<string, FormatReference>;
  nodes: IFormatReferenceTreeData[];
  selectedNode: IFormatReferenceTreeNode;

  @Prop()
  shouldAddRootFolder: boolean;

  get allowDuplication(): boolean {
    return true;  // コンフィグ等で切り替える必要が出てきた場合、ここを修正する
  }

  get editDialogModel(): FormatReferenceTreeEditDialogModel<FormatReference> {
    return this.editingSource;
  }

  get editingDirectories(): Directory<string, FormatReference>[] {
    return this.editDialogModel.editingDirectories;
  }

  get selectedDirectory(): Directory<string, FormatReference> {
    return this.editDialogModel.selectedDirectory;
  }

  set selectedDirectory(value: Directory<string, FormatReference>) {
    this.editDialogModel.selectedDirectory = value;
  }

  get selectedFormat(): FormatReference {
    return this.editDialogModel.selectedFormat;
  }

  set selectedFormat(value: FormatReference) {
    this.editDialogModel.selectedFormat = value;
  }

  get editFolderText(): string {
    return this.editDialogModel.editFolderText;
  }

  get editFormatText(): string {
    return this.editDialogModel.editFormatText;
  }

  get addFolderText(): string {
    return this.editDialogModel.addFolderText;
  }

  get addDirectory(): Directory<string, FormatReference> {
    return this.editDialogModel.addDirectory;
  }

  get addFormats(): FormatReference[] {
    return this.editDialogModel.addFormats;
  }

  get deleteFolderFlag(): boolean {
    return this.editDialogModel.deleteFolderFlag;
  }

  get deleteFormatFlag(): boolean {
    return this.editDialogModel.deleteFormatFlag;
  }

  get updateCompletedDirectoriesFlag(): boolean {
    return this.editDialogModel.updateCompletedDirectoriesFlag;
  }

  get completedDirectories(): Directory<string, FormatReference>[] {
    return this.editDialogModel.completedDirectories;
  }

  set completedDirectories(value: Directory<string, FormatReference>[]) {
    this.editDialogModel.completedDirectories = value;
  }

  @Watch("editingDirectories")
  onEditingDirectoriesChanged(newValue: Directory<string, FormatReference>[], oldValue: Directory<string, FormatReference>[]): void {
    this.loadNodes();
  }

  @Watch("editFolderText")
  onEditFolderTextChanged(newValue: string, oldValue: string): void {
    if (!newValue || newValue.length === 0) {
      return;
    }
    this.setNodeLabel(newValue);
  }

  @Watch("editFormatText")
  onEditFormatTextChanged(newValue: string, oldValue: string): void {
    if (!newValue || newValue.length === 0) {
      return;
    }
    this.setNodeLabel(newValue);
  }

  @Watch("addFolderText")
  onAddFolderTextChanged(newValue: string, oldValue: string): void {
    if (!newValue || newValue === "") {
      return;
    }
    this.addFolder(newValue);
  }

  @Watch("addDirectory")
  onAddFormatsChanged(newValue: FormatReference[], oldValue: FormatReference[]): void {
    if (!this.addFormats) {
      return;
    }
    if (this.allowDuplication) {
      this.addFormatPhrase(this.addFormats);
    } else {
      const formats = Enumerable.from(this.addFormats)
        .where(f => !this.anyFormatNodeId(f.id, this.nodes))
        .toArray();
      if (formats.length === 0) {
        this.$warn(this.$wording.format.name + "追加", "既に" + this.$wording.format.name + "が存在します");
        return;
      }
      if (formats.length !== this.addFormats.length) {
        this.$warn(this.$wording.format.name + "追加", "既に存在する" + this.$wording.format.name + "以外を追加します");
      }
      this.addFormatPhrase(formats);
    }
  }

  @Watch("deleteFolderFlag")
  onDeleteFolderFlagChanged(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      return;
    }
    this.deleteNode();
  }

  @Watch("deleteFormatFlag")
  onDeleteFormatFlagChanged(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      return;
    }
    this.deleteNode();
  }

  @Watch("updateCompletedDirectoriesFlag")
  onUpdateCompletedDirectoriesFlagChanged(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      return;
    }
    const tree = this.getTreeComponent();
    this.completedDirectories = FormatReferenceTreeEditor._nodeUtility.toFormatReferenceDirectories(tree.data);
  }

  private loadNodes(): void {
    // thisをバインドしておかないと実行時のthisが変わるのでアロー関数でバインド.
    this.factory = new DirectoryTreeNodesFactory(
      (e: FormatReference, i: number) => FormatReferenceTreeEditor._nodeUtility.toFormatNode(e, i));
    // nodesを算出プロパティで処理するとツリーの変更が行われるたびに呼び出され、ツリーの開閉状態が初期化されてしまうため分離した
    this.nodes = this.factory.create(this.editingDirectories);
    this.selectedNode = null;

    if (this.editingDirectories !== null
      && this.nodes.length < 1
      && this.defaultFolderName) {
      // ルートフォルダがない場合デフォルトフォルダを作成して選択
      this.$nextTick(() => {
        this.addFolder(this.defaultFolderName);
        this.expandRootFolder();
      });
    } else if (this.nodes.length === 1) {
      this.$nextTick(() => {
        this.expandRootFolder();
      });
    }
  }

  private expandRootFolder(): void {
    const tree = this.getTreeComponent();
    const node = tree as any; // rootが必要なのでanyに変換
    if (node) {
      const rootNode = node.root as IFormatReferenceTreeNode;
      if (rootNode.childNodes instanceof Array) {
        const directories = Enumerable.from(rootNode.childNodes)
          .where(n => n.data instanceof Object && n.data.source instanceof Directory).toArray();
        if (directories.length === 1) {
          const root = Enumerable.from(directories).first();
          root.expanded = true;
          this.handleNodeClicked(root.data, root, null);
          tree.setCurrentNode(root.data);
        }
      }
    }
  }

  private getTreeComponent(): ElTree<string, IFormatReferenceTreeData> {
    return this.$refs.tree as ElTree<string, IFormatReferenceTreeData>;
  }

  private anyFormatNodeId(formatId: number, nodes: IFormatReferenceTreeData[]): boolean {
    for (const node of nodes) {
      if (node.source instanceof FormatReference) {
        if (node.source.id === formatId) {
          return true;
        }
      } else if (node.children && (0 < node.children.length)) {
        if (this.anyFormatNodeId(formatId, node.children)) {
          return true;
        }
      }
    }
    return false;
  }

  get defaultFolderName(): string {
    return this.$configuration.behavior.format.favorite.defaultFolderName;
  }

  nodeClass(node: IFormatReferenceTreeNode): string {
    return FormatReferenceTreeEditor._nodeUtility.nodeIconClass(node);
  }

  nodeLabel(node: IFormatReferenceTreeNode): string {
    return node.label;
  }

  shouldShowNodeKey(data: IFormatReferenceTreeData): boolean {
    return data.source instanceof Directory && !!data.source.key && this.$configuration.behavior.setting.shouldShowTreeNodeKey;
  }

  nodeKey(data: IFormatReferenceTreeData): string {
    return this.shouldShowNodeKey(data) && data.source instanceof Directory
      ? " (" + data.source.key + ")"
      : "";
  }

  shouldShowNodeId(data: IFormatReferenceTreeData): boolean {
    return data.source instanceof FormatReference && !!data.source.id;
  }

  nodeId(data: IFormatReferenceTreeData): string {
    return this.shouldShowNodeId(data) && data.source instanceof FormatReference
      ? " (" + data.source.id + ")"
      : "";
  }

  handleNodeClicked(nodeObject: IFormatReferenceTreeData, nodeProperty: IFormatReferenceTreeNode, nodeSelf: any): void {
    const source = nodeObject.source;
    if (source instanceof Directory) {
      this.selectedDirectory = source;
      this.selectedFormat = null;
    }
    if (source instanceof FormatReference) {
      this.selectedDirectory = null;
      this.selectedFormat = source;
    }
    if (nodeProperty.childNodes instanceof Array && nodeProperty.childNodes.length === 0) {
      nodeProperty.expanded = false;  // 移動等でファイルが無くなっていた場合はとりあえず閉じる
    }
    this.selectedNode = nodeProperty;
  }

  private setNodeLabel(lable: string): void {
    if (this.selectedNode === null) {
      return;
    }
    const data = this.selectedNode.data;
    if (data.source instanceof Directory) {
      const source = data.source as Directory<string, FormatReference>;
      source.name = lable;
      data.label = lable;
    } else if (data.source instanceof FormatReference) {
      const source = data.source as FormatReference;
      source.name = lable;
      data.label = lable;
    }
  }

  private addFolder(lable: string): void {
    // 共通のpublishIdを使用するためfactory経由でデータを作成
    const dir = [
      new Directory<string, FormatReference>(null, lable, [], []
    )];
    const nodes = this.factory.create(dir);
    this.addNode(nodes[0]);
  }

  private addFormatPhrase(formats: FormatReference[]): void {
    // 共通のpublishIdを使用するためfactory経由でデータを作成
    const dir = [
      new Directory<string, FormatReference>(null, "tmp", [], formats)
    ];
    const nodes = this.factory.create(dir);
    Enumerable.from(nodes[0].children)
      .forEach(c => this.addNode(c));
  }

  private addNode(childData: IFormatReferenceTreeData): void {
    const tree = this.getTreeComponent();
    if (this.selectedNode === null || this.shouldAddRootFolder) {
      const node = tree as any; // rootが必要なのでanyに変換
      tree.append(childData, node.root);
    } else {
      tree.append(childData, this.selectedNode.data);
      this.sortNode(this.selectedNode);
      this.selectedNode.expanded = true;  // 追加したので開く
    }
  }

  private deleteNode(): void {
    if (this.selectedNode === null) {
      return;
    }
    const tree = this.getTreeComponent();
    tree.remove(this.selectedNode.data);
    this.selectedNode = null;
    this.selectedDirectory = null;
    this.selectedFormat = null;
  }

  allowDrop(draggingNode: IFormatReferenceTreeNode, dropNode: IFormatReferenceTreeNode, type: TreeNodeDropType): boolean {
    const dropNodeSource = dropNode.data.source;
    if (dropNodeSource instanceof FormatReference
      && type === "inner") {
      return false; // フォーマットの内側は全て禁止
    }
    const draggingNodeSource = draggingNode.data.source;
    if (draggingNodeSource instanceof FormatReference
      && dropNodeSource instanceof Directory
      && type !== "inner") {
      return false; // フォーマットはフォルダの内側以外禁止
    }
    if (draggingNodeSource instanceof Directory
      && draggingNodeSource.key
      && draggingNodeSource.key.length > 0
      && (dropNode.level !== 1 || type === "inner")) {
      return false; // キーが登録されているフォルダはルート以外禁止
    }
    return true;
  }

  allowDrag(draggingNode: IFormatReferenceTreeNode): boolean {
    return true;
  }

  nodeDrop(draggingNode: IFormatReferenceTreeNode, dropNode: IFormatReferenceTreeNode, type: TreeNodeDropType): void {
    this.sortNode(type === "inner"
      ? dropNode          // ドロップ先をソート
      : dropNode.parent); // ドロップした兄弟をソートするため親を渡す
    dropNode.expanded = true; // 追加したので開く
  }

  private sortNode(node: IFormatReferenceTreeNode): void {
    if (node.childNodes instanceof Array) {
      node.childNodes.sort((a: IFormatReferenceTreeNode, b: IFormatReferenceTreeNode) => {
        const sourceA = a.data.source instanceof Directory ? 0 : 1;
        const sourceB = b.data.source instanceof Directory ? 0 : 1;
        return sourceA - sourceB;
      });
    }
    if (node.data !== null && node.data.children instanceof Array) {
      node.data.children.sort((a: IFormatReferenceTreeData, b: IFormatReferenceTreeData) => {
        const sourceA = a.source instanceof Directory ? 0 : 1;
        const sourceB = b.source instanceof Directory ? 0 : 1;
        return sourceA - sourceB;
      });
    }
  }
}
